import React from 'react'

import { NavTab } from '../../../types/graphql'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

export const NavTabBar: React.FC<{
  freezeTabId?: string
  tabs: NavTab[]
  wrapItems?: boolean
}> = ({ freezeTabId, tabs, wrapItems = false }) => {
  const viewModel = useViewModel({ freezeTabId, tabs, wrapItems })
  return <Template {...viewModel} />
}
